import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Calendar } from "lucide-react";
import api from "@/lib/api";

export default function BlogTeaser() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/blogs?limit=3").then((r) => setPosts(r.data || [])).catch(() => setPosts([])).finally(() => setLoading(false));
  }, []);

  return (
    <section className="relative py-8 md:py-12" data-testid="blog-teaser-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="text-xs font-mono uppercase tracking-[0.25em] text-muted-foreground">Insights</div>
            <h2 className="mt-4 font-heading font-bold text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.02]">
              <span className="text-primary">Articles.</span>
            </h2>
          </div>
          <Link to="/blog" className="text-sm font-medium text-primary inline-flex items-center gap-1 hover:gap-2 transition-all" data-testid="blog-view-all">
            All articles <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        {loading ? (
          <div className="grid md:grid-cols-3 gap-4">
            {[0,1,2].map(i => <div key={i} className="h-64 card-clean animate-pulse" />)}
          </div>
        ) : posts.length === 0 ? (
          <div className="card-clean p-10 text-center">
            <div className="text-muted-foreground">Articles will appear here once published from the admin panel.</div>
          </div>
        ) : (
          <div className="grid md:grid-cols-3 gap-4">
            {posts.map((p) => (
              <Link
                key={p.slug}
                to={`/blog/${p.slug}`}
                className="group card-clean overflow-hidden"
                data-testid={`blog-teaser-${p.slug}`}
              >
                {p.cover_image ? (
                  <div className="aspect-[16/9] overflow-hidden bg-gradient-to-br from-primary/20 via-secondary/10 to-primary/5 relative">
                    <img
                      src={p.cover_image}
                      alt={p.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                      loading="lazy"
                      onError={(e) => { e.currentTarget.style.display = "none"; }}
                    />
                  </div>
                ) : (
                  <div className="aspect-[16/9] bg-gradient-to-br from-primary/25 via-secondary/15 to-primary/5" />
                )}
                <div className="p-6">
                  <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-[0.15em] text-primary">
                    <span>{p.category}</span>
                    <span>·</span>
                    <span className="text-muted-foreground inline-flex items-center gap-1"><Calendar className="w-3 h-3" /> {new Date(p.created_at).toLocaleDateString()}</span>
                  </div>
                  <h3 className="mt-3 font-heading font-bold text-xl leading-tight group-hover:text-primary transition-colors">{p.title}</h3>
                  <p className="mt-2 text-sm text-muted-foreground line-clamp-2">{p.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
